<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper" v-if="viewType == 'show'">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :md="4" :sm="12">
            <a-form-item label="名称">
              <a-input allowClear placeholder="请输入备件名称" v-debounce="searchQuery" v-model="queryParam.bjName" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="型号">
              <a-input allowClear placeholder="请输入备件型号" v-debounce="searchQuery" v-model="queryParam.bjModel" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label>
              <a-checkbox @change="insufficientChange" v-model="stockFlag">只看库存不足</a-checkbox>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <template v-if="pageType!=='select'">
        <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
        <a-button @click="handleExportXls('备品备件基本信息')" icon="download" type="primary">导出</a-button>
        <a-upload
          :action="importExcelUrl"
          :headers="tokenHeader"
          :multiple="false"
          :showUploadList="false"
          @change="handleImportExcel"
          name="file"
        >
          <a-button icon="import" type="primary">导入</a-button>
        </a-upload>
      </template>-->
      <!-- 高级查询区域 -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0&&pageType==='query'">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="viewType == 'show'">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
            >下载</a-button
          >
        </template>
        <template slot="remainstatus" slot-scope="text, record">
          <a-tag
            :color="$filterDictTextByCache('bpbj_inventory_color', record.leftCount >= record.prepareCount ? 1 : 0)"
            >{{ record.leftCount >= record.prepareCount ? '库存充足' : '库存不足' }}</a-tag
          >
        </template>
        <span slot="action" slot-scope="text, record" v-if="pageType === 'query'">
          <a @click="handleDetail(record)">详情</a>
        </span>
      </a-table>
    </div>

    <dev-bpbj-info-modal @ok="modalFormOk" ref="modalForm"></dev-bpbj-info-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DevBpbjInfoModal from './modules/DevBpbjInfoModal'

export default {
  name: 'DevInventoryList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    DevBpbjInfoModal
  },
  props: {
    pageType: {
      type: String,
      default: 'query'
    },
    viewType: {
      type: String,
      default: 'show'
    }
  },
  data() {
    return {
      stockFlag: false,
      description: '备品备件基本信息管理页面',
      queryParam: {
        bjName: ''
      },
      isorter: {
        column: 'bjName',
        order: 'desc'
      },
      // 表头
      columns: [
        {
          title: '备件名称',
          align: 'center',
          dataIndex: 'bjName',
          sorter: true
        },
        {
          title: '备件型号',
          align: 'center',
          dataIndex: 'bjModel',
          sorter: true
        },
        {
          title: '规格',
          align: 'center',
          dataIndex: 'bjModelSpec',
          sorter: true
        },
        {
          title: '设备厂家',
          align: 'center',
          dataIndex: 'manuName',
          sorter: true
        },
        {
          title: '单位',
          align: 'center',
          dataIndex: 'unit'
        },
        {
          title: '应备数量',
          align: 'center',
          dataIndex: 'prepareCount'
        },
        // 库存
        {
          title: '库存',
          align: 'center',
          dataIndex: 'leftCount',
          sorter: true
        },
        {
          title: '状态',
          align: 'center',
          scopedSlots: { customRender: 'remainstatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/spareparts/devBpbjInfo/stock/list',
        delete: '/spareparts/devBpbjInfo/delete',
        deleteBatch: '/spareparts/devBpbjInfo/deleteBatch',
        exportXlsUrl: '/spareparts/devBpbjInfo/exportXls',
        importExcelUrl: 'spareparts/devBpbjInfo/importExcel'
      },
      insufficient: false,
      dictOptions: {},
      stockFlag: false,
      superFieldList: []
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    selectTableList() {
      return this.selectionRows
    }
  },
  watch: {
    stockFlag: {
      handler(v) {
        this.queryParam.stockFlag = v ? 1 : 0
        this.insufficientChange()
      }
    }
  },
  methods: {
    insufficientChange(v) {
      //筛选库存是否充足
      this.queryParam.stockFlag = this.stockFlag ? 1 : 0

      this.searchQuery()
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'bjCode', text: '备件物资编码' })
      fieldList.push({ type: 'string', value: 'bjName', text: '备件名称' })
      fieldList.push({ type: 'string', value: 'bjModel', text: '备件型号' })
      fieldList.push({ type: 'string', value: 'bjModelSpec', text: '备件型号规格' })
      fieldList.push({ type: 'number', value: 'prepareCount', text: '应备数量' })
      fieldList.push({ type: 'string', value: 'unit', text: '单位' })
      fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型' })
      fieldList.push({ type: 'string', value: 'manuId', text: '设备厂家' })
      fieldList.push({ type: 'string', value: 'devModelId', text: '设备型号' })
      fieldList.push({ type: 'int', value: 'ageMonth', text: '寿命' })
      fieldList.push({ type: 'number', value: 'leftCount', text: '初始数量' })
      fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })

      this.superFieldList = fieldList
    }
    // getQueryParams () {
    //   var param = Object.assign({}, this.queryParam, this.isorter);
    //   param.field = this.getQueryField();
    //   param.pageNo = this.ipagination.current;
    //   param.pageSize = this.ipagination.pageSize;
    //   param.
    //   if (this.superQueryParams) {
    //     param['superQueryParams'] = encodeURI(this.superQueryParams)
    //     param['superQueryMatchType'] = this.superQueryMatchType
    //   }
    //   return filterObj(param);
    // },
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
